module.exports = __webpack_public_path__ + "058ad95638df3702701480528d169615.jpg";